export const blockIconsContentReport = (
	<span className='material-symbols-outlined'>report</span>
);
